import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  Renderer2,
  viewChild,
} from '@angular/core';
import { AnnouncementService } from '../../services/announcement.service';
import { AnnouncementDto } from '../../dtos/announcement.dto';
import { DEFAULT_ERROR_TEXT } from '../../constants';
import { DeviceService } from '../../services/device-detector/device.service';
import { ToolbarService } from '../../services/toolbar.service';
import { DOCUMENT } from '@angular/common';
import { WindowResizeService } from '../../services/window-resize.service';
import { onWindowLoad } from '../../helpers/on-window-load.function';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  imports: []
})
export class AnnouncementComponent implements OnInit {
  private document = inject<Document>(DOCUMENT);
  private announcementService = inject(AnnouncementService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private deviceService = inject(DeviceService);
  private renderer = inject(Renderer2);
  private toolbarService = inject(ToolbarService);
  private windowResizeService = inject(WindowResizeService);


  public announcement: AnnouncementDto;
  public fetchError: string | null = null;

  public type: 'winterHolidays' | 'springHolidays' | 'attention';

  readonly announcementEl = viewChild('announcementRef', { read: ElementRef });

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.fetchAnnouncement();
    this.handleWindowResize();

    onWindowLoad(() => this.fetchAnnouncement());
  }

  private fetchAnnouncement() {
    return this.announcementService.getAnnouncement().subscribe(
      response => {
        this.announcement = response.data;

        if (!this.announcement || !this.deviceService.isPlatformBrowser()) { return; }

        if (this.announcement.isFixed) {
          this.changeDetectorRef.detectChanges();
        }

        this.updateSavedElHeight();
      },
      error => this.fetchError = error.error?.message || DEFAULT_ERROR_TEXT
    );
  }

  private handleWindowResize() {
    this.windowResizeService.resized$
      .pipe( takeUntilDestroyed(this.destroyRef) )
      .subscribe(() => this.updateSavedElHeight());
  }

  private updateSavedElHeight() {
    if (!this.announcement?.isFixed) {
      return;
    }

    this.toolbarService.announcementElHeight = this.announcementEl().nativeElement.getBoundingClientRect().height;
    this.renderer.setStyle(this.document.body, 'margin-top', `${this.toolbarService.announcementElHeight}px`);
  }
}
